import {
  CREATE_TASK,
  DELETE_TASK,
  FETCH_TASK_QUEUE,
  FETCH_TASK_QUEUE_REALTOR,
  SEND_MESSAGE,
  TASK_SELECTED,
} from '../../_actions/types';

const defaultState = {
  newTask: '',
  expanded: false,
  open: false,
  taskDialogOpen: false,
  activeTask: {},
  project: '',
  newDescription: '',
  newTitle: '',
  taskQueue: [],
  notifications: [],
};

export default function (state = defaultState, action) {
  switch (action.type) {

    case CREATE_TASK:
      return { ...state, newTask: '' };
    case DELETE_TASK:
      return { ...state };
    case FETCH_TASK_QUEUE:
      return { ...state, taskQueue: action.payload}
    case FETCH_TASK_QUEUE_REALTOR:
      return { ...state, taskQueue: action.tasks}
    case SEND_MESSAGE:
      return { ...state, /*activeTask: action.payload*/}
    case TASK_SELECTED:
      return { ...state, activeTask: action.payload }
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/components/project/project_reducer.js